import { Controller } from 'stimulus'

// Keep in step with ChatBot::WorkflowRunComponent.duration_label — the server renders the
// first label and this takes over from there, so a mismatch shows up as a jump on connect.
const durationLabel = (seconds) => {
  if (seconds < 60) return `${seconds}s`

  const minutes = Math.floor(seconds / 60)
  if (minutes < 60)
    return `${minutes}m ${String(seconds % 60).padStart(2, '0')}s`

  return `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(
    2,
    '0'
  )}m`
}

export default class extends Controller {
  static targets = ['elapsed']
  static values = { startedAt: String, endedAt: String }

  connect() {
    this.restartClock()
  }

  disconnect() {
    clearInterval(this.timer)
  }

  // A push morphs the strip's attributes in place, so the controller is never reconnected. Without
  // taking the new values here a run that just ended would go on counting past its own finish.
  startedAtValueChanged() {
    this.restartClock()
  }

  endedAtValueChanged() {
    this.restartClock()
  }

  restartClock() {
    clearInterval(this.timer)
    if (this.endedAtValue) return

    this.startedAt = Date.parse(this.startedAtValue)
    if (Number.isNaN(this.startedAt)) return

    this.timer = setInterval(() => this.tick(), 1000)
  }

  tick() {
    if (!this.hasElapsedTarget) return

    const seconds = Math.max(
      0,
      Math.round((Date.now() - this.startedAt) / 1000)
    )
    this.elapsedTarget.textContent = durationLabel(seconds)
  }
}
